import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ChatThreadComponent } from "./chat-thread/chat-thread.component";

/**
 * The coaching conversation view, shared by the coach panel and the student app. Transport stays
 * with each app: they authenticate differently and talk to different paths.
 */
@NgModule({
  declarations: [ChatThreadComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, NgxSkeletonLoaderModule],
  exports: [ChatThreadComponent],
})
export class ChatModule {
}
